import PropTypes from 'prop-types';
import pick from 'lodash/pick';

import config from '@plone/volto/registry';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

const ALLOWED_BLOCKS = ['csjCard', 'slate', 'csjIconCardGrid', 'image'];

const ColumnBlocksView = ({ blocks, blocksLayout, path, metadata }) => {
  if (!blocksLayout?.items?.length) {
    return null;
  }

  const blocksConfig = pick(config.blocks.blocksConfig, ALLOWED_BLOCKS);

  return (
    <RenderBlocks
      content={{
        blocks: blocks || {},
        blocks_layout: blocksLayout || { items: [] },
      }}
      path={path}
      metadata={metadata}
      blocksConfig={blocksConfig}
    />
  );
};

ColumnBlocksView.propTypes = {
  blocks: PropTypes.objectOf(PropTypes.any),
  blocksLayout: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.string),
  }),
  path: PropTypes.string,
  metadata: PropTypes.objectOf(PropTypes.any),
};

const ColumnGridBody = ({ data, path, metadata }) => (
  <div className="column-grid-columns">
    <div className="column-grid-column-wrapper">
      <ColumnBlocksView
        blocks={data.left_blocks}
        blocksLayout={data.left_blocks_layout}
        path={path}
        metadata={metadata}
      />
    </div>
    <div className="column-grid-column-wrapper">
      <ColumnBlocksView
        blocks={data.right_blocks}
        blocksLayout={data.right_blocks_layout}
        path={path}
        metadata={metadata}
      />
    </div>
  </div>
);

ColumnGridBody.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  path: PropTypes.string,
  metadata: PropTypes.objectOf(PropTypes.any),
};

export default ColumnGridBody;
